import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AvatarModule } from '@epicuro-next/ataraxia/avatar';
import { dynamicElementsAuthorKey } from '@epicuro-next/constants/dynamic-elements';
import { DontTreeShake } from '@epicuro-next/elements/core';
import { UserInfo } from '@epicuro-next/models/engagement';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';

@DynamicComponentRegister(dynamicElementsAuthorKey, true)
@Component({
  imports: [AvatarModule, DatePipe],
  selector: 'epc-dynamic-elements-author',
  templateUrl: './dynamic-author.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicAuthorComponent {
  @Input()
  public user: UserInfo | null = null;

  @Input()
  public date: Date | null = null;

  @Input() public dateFormat = 'MMM d, yyyy';
}

DontTreeShake(DynamicAuthorComponent);
